import { render, staticRenderFns } from "./legalperson.vue?vue&type=template&id=5bc43ebd&scoped=true&"
import script from "./legalperson.vue?vue&type=script&lang=js&"
export * from "./legalperson.vue?vue&type=script&lang=js&"
import style0 from "./legalperson.vue?vue&type=style&index=0&id=5bc43ebd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc43ebd",
  null
  
)

export default component.exports